import { Box, Typography } from "@mui/material";
import LockOutlined from "@mui/icons-material/LockOutlined";
import React from "react";
import { COURSE_DEMO_UNLOCK_MESSAGE } from "../../../utils/courseDemo";

type CourseDemoLockOverlayProps = {
    /** When true, overlay is always visible (e.g. small list rows). Default: show on hover. */
    alwaysVisible?: boolean;
    /** Hide the message from AT when the host already announces it. */
    hideMessage?: boolean;
};

/**
 * Theme-green lock overlay for Explore items not entitled on a course demo licence.
 */
export const CourseDemoLockOverlay = ({
    alwaysVisible = false,
    hideMessage = false,
}: CourseDemoLockOverlayProps): JSX.Element => (
    <Box
        className="course-demo-lock-overlay"
        aria-hidden={hideMessage || undefined}
        sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            px: 1,
            textAlign: "center",
            bgcolor: "primary.main",
            color: "primary.contrastText",
            opacity: alwaysVisible ? 0.92 : 0,
            transition: "opacity 160ms ease",
            pointerEvents: "none",
            zIndex: 2,
            "@media (hover: none)": {
                opacity: 0.92,
            },
        }}
    >
        <LockOutlined fontSize="large" />
        <Typography
            variant="subtitle2"
            sx={{ fontWeight: 700, lineHeight: 1.3 }}
            aria-hidden={hideMessage || undefined}
        >
            {COURSE_DEMO_UNLOCK_MESSAGE}
        </Typography>
    </Box>
);
